import { breakpointsVuetifyV3, useBreakpoints } from '@vueuse/core'

export const useVuetifyBreakpoints = () => useBreakpoints(breakpointsVuetifyV3)
